export const getSubscriberIdFromToken = token => {
  const decodedTokens = atob(token);
  return decodedTokens.split(':')[2];
};
